import { Component, OnInit } from '@angular/core';
import { Key, KpdNavigator } from '@kpd/framework-ngx';
import { PermissionsNavigatorHelper } from 'app/permissions/permissions-navigator-helper';
import { PermissionFacade } from 'app/shared/services/facades/permission.facade';
import { Permissions } from 'app/shared/services/permissions';
import { Permission } from 'app/shared/models/permission';
import { PermissionService } from 'app/shared/services/permission.service';

@Component({
  selector: 'app-permissions-sidepanel',
  templateUrl: './permissions-sidepanel.component.html',
})
export class PermissionsSidepanelComponent implements OnInit {
  permission: Permission | null;
  Permissions: typeof Permissions = Permissions;
  navigatorHelper: PermissionsNavigatorHelper;
  permissionSetCount? = 0;
  roleCount? = 0;
  userCount? = 0;
  loading: boolean[] = [];

  constructor(
    public permissionFacade: PermissionFacade,
    private navigator: KpdNavigator,
    private permissionService: PermissionService,
  ) {
    this.navigatorHelper = new PermissionsNavigatorHelper(navigator);
  }

  onItemChange(item: Permission): void {
    delete this.permissionSetCount;
    delete this.roleCount;
    delete this.userCount;
    if (!!item) {
      this.loading.push(true);
      this.permissionService.getPermissionSets(item.id).subscribe((sets) => {
        this.permissionSetCount = sets.length;
        this.loading.pop();
      });
      this.loading.push(true);
      this.permissionService.getUsers(item.id).subscribe((users) => {
        this.userCount = users.length;
        this.loading.pop();
      });
      this.loading.push(true);
      this.permissionService.getRoles(item.id).subscribe((roles) => {
        this.roleCount = roles.length;
        this.loading.pop();
      });
    }
  }

  ngOnInit(): void {}

  onView(permissionKey: Key<string>): void {
    this.navigatorHelper.navigateToConsult(permissionKey);
  }

  navigateToPermissionsets(id: string): void {
    this.navigator.navigateChild(['permissions', 'details', id], { queryParams: { tab: 'permissionsets' } });
  }
  navigateToRoles(id: string): void {
    this.navigator.navigateChild(['permissions', 'details', id], { queryParams: { tab: 'roles' } });
  }
  navigateToUsers(id: string): void {
    this.navigator.navigateChild(['permissions', 'details', id], { queryParams: { tab: 'users' } });
  }
}
